import React, { useState, useEffect } from 'react';
import { Form, Dropdown, Input, Grid, Button, Label, Segment } from 'semantic-ui-react';
import EditReminder from './CreateReminder';

import './style.less';

const ReminderItem = ({reminder, handleDuplicate, handleDelete, handleEditSubmit, handleClear}) => {
    const [isUpdateEnabled, setIsUpdateEnabled] = useState<boolean>(false);
    const [tempReminder, setTempReminder] = useState({
        timestamp: { ...reminder.timestamp },
        desc: reminder.desc,
        frequency: reminder.frequency
    });

    // console.log('reminder', reminder);
    const onEdit = () => {
        setIsUpdateEnabled(true);
    };
    const onEditCancel = () => {
        setIsUpdateEnabled(false);
        setTempReminder({
            timestamp: (reminder.timestamp),
            desc: reminder.desc,
            frequency: reminder.frequency
        });
    };
    const onEditChange = (input, value) => {
        let month = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        value = input === 'timestamp' ? {
            day: (new Date(value)).getDate(),
            month: month[(new Date(value)).getMonth()],
            year: (new Date(value)).getFullYear(),
            timeHours: (new Date(value)).getHours(),
            timeMinutes: (new Date(value)).getMinutes()
        } : value;

        setTempReminder({
            ...tempReminder,
            [input]: value
        });
    };
    const onEditSubmit = async (reminderId, reminder) => {
        setIsUpdateEnabled(false);
        const response = await handleEditSubmit(reminderId, reminder);
        if (response === false) {
            setIsUpdateEnabled(true);
        }
    };
    const timeHandler = (hours, minutes) => {
        if (Number(hours) === 0) {
            return `12:${minutes} AM`;
        } else if (Number(hours) === 12) {
            return `12:${minutes} PM`;
        }
        return Number(hours) < 12 ? `${hours}:${minutes} AM` : `${Number(hours) - 12}:${minutes} PM`;
    };

    const generateFlag = (reminder) => {
        if (reminder.isDeletedOutsideSkill) return 'Deleted';
        if (reminder.isRejected) return 'Rejected';
        if (reminder.isDeleteRequested) {
            return 'Delete';
        } else if (reminder.edit) {
            return 'Edit';
        } else if (!reminder.alertToken) {
            return 'Creation';
        } 
    };

    const flag = generateFlag(reminder);

    const hasReminderExpired = (reminder) => {
        const { timestamp } = reminder;
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();
        const day = today.getDate();
        const hr = today.getHours();
        const min = today.getMinutes();
        const monthStrings = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        
        if (reminder.frequency === 'Once') { 
            if (timestamp.year < year) { 
                return true;
            } else if (timestamp.year === year && monthStrings.indexOf(timestamp.month) < month) { 
                return true;
            } else if (timestamp.year === year && monthStrings.indexOf(timestamp.month) === month && timestamp.day < day) { 
                return true;
            } else if (timestamp.year === year && monthStrings.indexOf(timestamp.month) === month && timestamp.day === day && timestamp.timeHours < hr) { 
                return true;
            } else if (timestamp.year === year && monthStrings.indexOf(timestamp.month) === month && timestamp.day === day && timestamp.timeHours === hr && timestamp.timeMinutes < min) { 
                return true;
            }
        }
        return false;
    };

    return (
        <>
            {isUpdateEnabled ? (
                <EditReminder
                    handleSubmit={()=>onEditSubmit(reminder._id, tempReminder)}
                    formData={tempReminder}
                    handleChange={onEditChange}
                    editMode={true}
                    onEditCancel = {onEditCancel}
                />
            ) : (
                hasReminderExpired(reminder) ? 
                <></> 
                :
                <div style={{margin: '20px 0'}}>
                    <Segment padded >
                        {flag ==='Deleted' && <Label attached='top left' color='grey'>{flag}</Label>}
                        {flag ==='Rejected' && <Label attached='top left' color='grey'>Not accepted</Label>}
                        {flag ==='Delete' && <Label attached='top left' color='red'>{flag} requested</Label>}
                        {flag ==='Edit' && <Label attached='top left' color='yellow'>{flag} requested</Label>}
                        {flag ==='Creation' && <Label attached='top left' color='blue'>{flag} requested</Label>}

                        <Grid>
                            <Grid.Row>
                                <Grid.Column floated='left' width={4}>
                                    { reminder.edit ? (
                                        `${reminder.edit.timestamp.day} ${reminder.edit.timestamp.month} ${reminder.edit.timestamp.year}, ${timeHandler(reminder.edit.timestamp.timeHours, String(reminder.edit.timestamp.timeMinutes).length > 1 ? reminder.edit.timestamp.timeMinutes : '0'+reminder.edit.timestamp.timeMinutes)}`
                                    ) : (
                                        `${reminder.timestamp.day} ${reminder.timestamp.month} ${reminder.timestamp.year}, ${timeHandler(reminder.timestamp.timeHours, String(reminder.timestamp.timeMinutes).length > 1 ? reminder.timestamp.timeMinutes : '0'+reminder.timestamp.timeMinutes)}`
                                    )}                                        
                                </Grid.Column>
                                <Grid.Column floated='left' width={5}>
                                    {reminder.edit ? reminder.edit.desc : reminder.desc}
                                </Grid.Column>
                                <Grid.Column floated='left' width={3}>
                                    Repeats{' '}{reminder.edit ? reminder.edit.frequency : reminder.frequency}
                                </Grid.Column>
                                <Grid.Column floated='right' width={1}>
                                    <Button circular icon='refresh' style={{backgroundColor: 'transparent', paddingTop: '0px'}} 
                                    onClick={() => {handleDuplicate(reminder)}}/>
                                </Grid.Column>
                                <Grid.Column width={1}>
                                    {!(flag ==='Delete') && //don't show dropdown if a delete is requested
                                    <Dropdown icon='ellipsis vertical'>
                                        {reminder.isRejected || reminder.isDeletedOutsideSkill ? (    
                                            <Dropdown.Menu>
                                                <Dropdown.Item text='Clear' onClick={()=> handleClear(reminder)}></Dropdown.Item>
                                            </Dropdown.Menu>
                                            ) : (
                                            <Dropdown.Menu>
                                                { reminder.alertToken && !reminder.isDeleteRequested && !reminder.edit &&
                                                    <Dropdown.Item text='Edit' onClick={()=>onEdit()} />
                                                }
                                                <Dropdown.Item text='Delete' onClick={()=> handleDelete(reminder)}></Dropdown.Item>
                                            </Dropdown.Menu>
                                        )}
                                    </Dropdown>}                          
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Segment>
                </div>
            )}
        </>
    );
};

export default ReminderItem;
